import { UiKit } from '@datavant/uikit';

export const shouldUseNewBranding = (): boolean => {
    return true;
};

export const DEFAULT_FONT = shouldUseNewBranding() ? "'DM Sans', sans-serif" : 'Lato, sans-serif';
export const PRIMARY_BLUE = shouldUseNewBranding() ? '#006CCF' : '#004CAD';
export const PAGE_BACKGROUND = shouldUseNewBranding()
    ? UiKit.consistency.white
    : UiKit.consistency.pageBackground;
